





import {Component, Prop, Vue} from "vue-property-decorator";
import Time from "./Time";
import {Getter} from "vuex-class";

@Component
export default class Timer extends Vue {
    @Prop({type: String}) private data_time!: string;
    @Prop({type: Boolean, default: false}) private data_stop!: boolean;
    @Prop({type: String, required: true}) private value!: string;

    public seconds: number = 0;
    public time!: Time;
    public timer: any = null;

    mounted() {
        this.setTime();
        this.start();
    }

    setTime() {
        // const time: string[] = this.data_time.split(":");
        this.time = new Time(this.data_time);
        this.seconds = this.time.timeInSeconds;
    }

    start() {
        if (!this.timer) {
            this.timer = setInterval(() => {
                if (this.seconds > 0 && !this.data_stop) {
                    this.seconds--;
                    this.$emit('input', this.prettyTime)
                } else {
                    clearInterval(this.seconds);
                    this.stop();
                    this.$emit("timeout");
                }
            }, 1000);
        }
    }

    stop() {
        clearInterval(this.timer);
        this.timer = null;
    }

    reset() {
        this.stop();
        this.seconds = 0;
    }


    get prettyTime(): string {
        return (new Time(this.seconds)).toString();
    }
}
